document.addEventListener("turbo:load", function () {
  if (!App.currentPageIs("step1", "new")) {
    return
  }

  // The deferred loading of the intl-tel-input utils file is not well supported by Capybara so it makes the tests
  // fail. For this reason, we skip the JS phone number formatting / validation part during tests.
  if (gon.environment === "test") {
    return
  }

  App.whenAvailable("intlTelInput", function () {
    const phoneNumberField = document.querySelector("#phone-number-field")

    let initialCountry = ""

    const userCountry = App.user.attributes.sign_in_country
    if (userCountry) {
      // We set the initial country from the user only if it's part of the countries known by intl-tel-input lib.
      intlTelInput.getCountryData().forEach(function (country) {
        if (country.iso2 === userCountry.toLowerCase()) {
          return (initialCountry = userCountry)
        }
      })
    }

    const iti = window.intlTelInput(phoneNumberField, {
      initialCountry,
      countryOrder: [initialCountry, "us", "in", "gb", "ph", "cn", "fr", "ca"],
    })

    $("#validate_phone_number_form").submit(function () {
      if (iti.isValidNumber()) {
        phoneNumberField.value = iti.getNumber()
        return true
      } else {
        $("#phone-number-error-message").html(i18n.t("js.front.validate_phone_number.step1.invalid_phone_number"))
        App.enableForm()
        return false
      }
    })

    return $("#phone-number-field").on("input", () => $("#phone-number-error-message").html(""))
  })
})
